export function extractPolicyExpirationDate(signedUrl: string): Date | null {
  try {
    const url = new URL(signedUrl);
    const policyBase64 = url.searchParams.get('Policy');
    if (!policyBase64) {
      throw new Error('No Policy query param found');
    }

    const base64 = normalizeBase64(policyBase64);
    const jsonString = atob(base64);
    const policy = JSON.parse(jsonString);

    const expirationTime =
      policy.Statement[0].Condition.DateLessThan['AWS:EpochTime'];

    return new Date(expirationTime * 1000);
  } catch (error) {
    console.error('Failed to check CloudFront URL expiration:', error);
    return null;
  }
}

function normalizeBase64(str: string): string {
  return str.replace(/-/g, '+').replace(/_/g, '=').replace(/~/g, '/');
}
